import React from "react";
import PropTypes from "prop-types";
import styles from "./tick.css";

const HUNDRED = 100;
const TWO = 2;
const Tick = ({ index, tick, format, count, showTickText, tickStyle, tickTextStyle, mainDivisorHeight}) => {
    return (
        <div style={{position: "relative"}}>
            <div styleName={"styles.sliderTicks"}
                style={{
                    left: `${tick.percent}%`,
                    ...tickStyle,
                    ...((typeof mainDivisorHeight === "string"  && index % TWO === 0) && {height: mainDivisorHeight})
                }}
            />
            {showTickText(tick.value) && <div
                className="slider-tick-text"
                style={{
                    position: "absolute",
                    marginTop: 12,
                    fontSize: 14,
                    fontWeight: 600,
                    textAlign: "center",
                    marginLeft: `${-(HUNDRED / count) / TWO}%`,
                    width: `${HUNDRED / count}%`,
                    left: `${tick.percent}%`,
                    color: "#333333",
                    fontFamily: "Inter",
                    ...tickTextStyle
                }}
            >
                {format(tick.value)}
            </div>}
        </div>
    );
};

Tick.propTypes = {
    tick: PropTypes.shape({
        id: PropTypes.string.isRequired,
        value: PropTypes.number.isRequired,
        percent: PropTypes.number.isRequired
    }).isRequired,
    count: PropTypes.number.isRequired,
    format: PropTypes.func.isRequired,
    tickStyle: PropTypes.object,
    showTickText: PropTypes.func,
    mainDivisorHeight: PropTypes.string, // height of main divisor in px
    tickTextStyle: PropTypes.object,
    index: PropTypes.number
};

Tick.defaultProps = {
    format: d => d,
    showTickText: () => false,
    tickTextStyle: {
        marginTop: "16px"
    }
};

export default Tick;
